module.exports = __webpack_public_path__ + "img/circle_exclamation.a19bb4b0.svg";